<template>
  <div v-if="isShow" class="popFixed">
    <div class="masking" @click="blacklist" />
    <div class="tcCon">
      <div class="item">
        <span>温馨提示</span>
        <p>平台暂停存款，给您带来不便，敬请谅解</p>
      </div>
      <div class="btnCon only">
        <span @click="blacklist">确定</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlackListPop',
  props: ['source', 'isBlackList', 'pageType'],
  data() {
    const u = navigator.userAgent
    return {
      isShow: this.isBlackList,
      isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
      isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    }
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    blacklist() {
      if (this.pageType == 'app') {
        try {
          let v
          if (this.isIOS) {
            if (typeof (window.closeAction) != 'undefined') {
              v = window.closeAction()
            } else {
              v = window.webkit.messageHandlers.closeAction.postMessage(null)
            }
          } else {
            v = window.uiObject.closeAction()
          }
        } catch (e) {
          alert(e)
        }
      } else {
        if (this.source == 'home') {
          this.removeFixed()
          this.isShow = false
          this.$emit('changeBlack', this.isShow)
        } else if (this.source == 'recharge') {
          this.$router.go(-1)
        }
      }
    },
    goIdentity() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/identity' })
    }
  }
}
</script>
